import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { updatePaymentProcessor, createPaymentProcessor } from "../../slices/paymentprocessors";
import { useNavigate } from 'react-router-dom';

const PaymentProcessorForm = ({ paymentProcessor }) => {

    let timer = null;

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const confForms = useSelector(state => state.paymentprocessorconfiguration.forms)

    const [paymentProcessorType, setPaymentProcessorType] = React.useState(paymentProcessor?.payment_processor)

    const onSubmit = (data) => {
        if (paymentProcessor) {
            Promise.resolve(dispatch(updatePaymentProcessor({ id: paymentProcessor.id, args: data })))
                .then(data => {
                    navigate('/settings/paymentprocessors/')
                })
        } else {
            Promise.resolve(dispatch(createPaymentProcessor(data)))
                .then(data => {
                    navigate('/settings/paymentprocessors/')
                })
        }
    }

    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        getValues,
        formState: { errors }
    } = useForm({
        defaultValues: {
            name: paymentProcessor?.name,
            configuration: paymentProcessor?.configuration,
            payment_processor: paymentProcessor?.payment_processor
        }
    });

    const paymentProcessorTypes = [{key: '', value: gettext('Choose payment processor type')}].concat(Object.keys(confForms).map(c => { return { key: confForms[c].slug, value: confForms[c].display_name } }))

    useEffect(() => {
        const newValue = paymentProcessor?.payment_processor
        setPaymentProcessorType(newValue)
    }, [confForms]);

    useEffect(() => {
        const formWatcher = watch(() => {
            const newValue = getValues('payment_processor')
            setPaymentProcessorType(newValue)
            setValue('payment_processor', newValue)
        });
        return () => formWatcher.unsubscribe();
    }, [watch]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="contentarea clamped">
                <div className="container-fluid detail">
                    <div className="row">
                        <div className="col mb-4">
                            <div className="mb-4">
                                <label htmlFor="name">{gettext('Name')}</label>
                                <input type="text" id="name" {...register('name')} className="form-control" />
                            </div>
                        </div>
                    </div>
                    {!paymentProcessor &&
                        <div className="row">
                            <div className="col mb-4">
                                <label>{gettext("Type")}</label>
                                <select className="form-select" {...register('payment_processor')}>
                                    {paymentProcessorTypes.map((pType) => {
                                        return (
                                            <option value={pType.key}>{pType.value}</option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                    }
                    {paymentProcessorType && Object.keys(confForms[paymentProcessorType].fields).map((f, i) => {

                        const field = confForms[paymentProcessorType].fields[f]

                        if (field.title === "BooleanField") {
                            return (
                                <div className="row">
                                    <div className="col mb-4">

                                        <div className="mb-4">
                                            <div className="form-check form-switch">
                                                <input className="form-check-input" {...register(`configuration.${f}`)} type="checkbox" role="switch" id={`f-${i}`} />
                                                <label className="form-check-label" htmlFor={`f-${i}`}>{field.label}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        } else {
                            return (
                                <div className="row">
                                    <div className="col mb-4">

                                        <div className="mb-4">
                                            <label>{field.label}</label>
                                            <input type="text" {...register(`configuration.${f}`)} className="form-control" />
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    })}
                </div>
            </div>
            <div className="clamped text-end">
                <input className="btn btn-primary mt-4 ms-auto" type="submit" value={gettext("Save")} />
            </div>
        </form >
    )
}

export default PaymentProcessorForm